import React from 'react';
import { Link } from 'react-router-dom';
import { Github, Linkedin, Mail, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-section">
          <h3>Itrat Zehra Jassani</h3>
          <p>Senior Project Manager passionate about bridging technology and strategy for digital transformation.</p>
          <div className="social-links">
            <a href="https://www.linkedin.com/in/itrat-zehra-jassani" target="_blank" rel="noopener noreferrer" className="social-link">
              <Linkedin size={20} />
            </a>
            <a href="https://github.com/itratjassani" target="_blank" rel="noopener noreferrer" className="social-link">
              <Github size={20} />
            </a>
            <a href="mailto:itratjassani@gmail.com" className="social-link">
              <Mail size={20} />
            </a>
            <a href="https://twitter.com/itratjassani" target="_blank" rel="noopener noreferrer" className="social-link">
              <Twitter size={20} />
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/projects">Projects</Link>
          <Link to="/blog">Blog</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="footer-section">
          <h3>Services</h3>
          <p>Project Management</p>
          <p>Technical Leadership</p>
          <p>Digital Transformation</p>
          <p>Product Strategy</p>
          <p>Team Mentorship</p>
        </div>

        <div className="footer-section">
          <h3>Contact</h3>
          <p>Karachi, Sindh, Pakistan</p>
          <a href="mailto:itratjassani@gmail.com">itratjassani@gmail.com</a>
          <p>Open to remote opportunities</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Itrat Zehra Jassani. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;